import { Box, Typography } from "@mui/material";
import loaderStyles from "./loader.module.css";
export const Loader = ({ message = "LOADING DATA" }) => {
  return (
    <Box
      sx={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        height: "100vh",
      }}
    >
      <div className={loaderStyles.loader} />
      <Typography
        sx={{
          textAlign: "center",
          padding: "20px",
          textTransform: "uppercase",
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};
